const all = ['overviewStatistics'];

export const keys = { all };
